import { Col, Typography } from "antd";
import "./styles.scss";
import BlogParagraph from "../../../components/blog-paragraph/blog-paragraph";
import CustomRow from "../../../shared/costum-row/costum-row";

const { Title, Text } = Typography;

const LegalPage = () => {
  return (
    <div className="LegalPage">
      <Title className="LegalPage-title-main">Data Security</Title>
      <CustomRow gutter={[0, 25]} className="LegalPage-content">
        <Col span={24}>
          <Title className="LegalPage-title">Lorem ipsum dolor sit</Title>
        </Col>
        <Col span={24}>
          <Text className="LegalPage-desc">
            In den USA ist es landesweit zu Protesten gegen Massenentlassungen
            in den Behörden durch den Unternehmer und Regierungsbeauftragten
            Elon Musk gekommen. Hunderte Menschen demonstrierten vor
            Tesla-Geschäften in Florida, Arizona oder New York. Demonstranten
            blockierten den Verkehr und schwenkten Transparente mit Aufschriften
            wie "Verbrennt einen Tesla: Rettet die Demokratie" und "Keine
            Diktatoren in den USA". Bei der Demonstration vor einem
            Tesla-Autohaus in New York wurden dabei laut Polizei neun Menschen
            festgenommen. Die Proteste richteten sich gegen Tesla-Chef Musk, der
            als Sonderbeauftragter in der neuen sogenannten Behörde für
            Regierungseffizienz (DOGE) unter US-Präsident Donald Trump
            umfangreiche Kürzungen im Bundesdienst anordnete. Die Organisatoren
            der landesweiten Protestaktion "Tesla Takedown" riefen auch dazu
            auf, Tesla-Aktien zu verkaufen.{" "}
          </Text>
        </Col>
      </CustomRow>
      <CustomRow gutter={[0, 25]} className="LegalPage-content">
        <Col span={24}>
          <Title className="LegalPage-title">Lorem ipsum dolor sit</Title>
        </Col>
        <Col span={24}>
          <Text className="LegalPage-desc">
            In den USA ist es landesweit zu Protesten gegen Massenentlassungen
            in den Behörden durch den Unternehmer und Regierungsbeauftragten
            Elon Musk gekommen. Hunderte Menschen demonstrierten vor
            Tesla-Geschäften in Florida, Arizona oder New York. Demonstranten
            blockierten den Verkehr und schwenkten Transparente mit Aufschriften
            wie "Verbrennt einen Tesla: Rettet die Demokratie" und "Keine
            Diktatoren in den USA". Bei der Demonstration vor einem
            Tesla-Autohaus in New York wurden dabei laut Polizei neun Menschen
            festgenommen. Die Proteste richteten sich gegen Tesla-Chef Musk, der
            als Sonderbeauftragter in der neuen sogenannten Behörde für
            Regierungseffizienz (DOGE) unter US-Präsident Donald Trump
            umfangreiche Kürzungen im Bundesdienst anordnete. Die Organisatoren
            der landesweiten Protestaktion "Tesla Takedown" riefen auch dazu
            auf, Tesla-Aktien zu verkaufen.{" "}
          </Text>
        </Col>
      </CustomRow>
    </div>
  );
};

export default LegalPage;
